<template>
	<div>
		<div class="form-box">
	        <form @submit.prevent="SubmitForm">
	            <h5>Member Portal Login</h5>
	            <div class="form-group">
	                <label for="loginEmail" class="control-label">Email Address</label>
	                <input v-model="form.email" type="email" id="loginEmail" name="email" class="form-control input-sm" placeholder="" required="true" value="" v-bind:class="{'form-error': errors}">
	                <span v-if="errors" class="text-danger">{{ errors }}</span>
	            </div>
	            <div class="form-group">
	                <label for="loginPassword" class="control-label">Password</label>
	                <input v-model="form.password" type="password" name="password" class="form-control input-sm" placeholder="" required="true" id="loginPassword">
	            </div>
	            <!-- <div class="checkbox">
	                <label>
	                    <input type="checkbox" value="1" id="rememberMe" name="data[Member][rememberMe]"> Remember me
	                </label>
	            </div> -->
	            <div class="forgot-password-link">
	                <a href="https://members.asifa-hollywood.org/account-lookup">Account Lookup Tool</a>
	                <div class="divider"></div>
	                <a href="https://members.asifa-hollywood.org/forgot-password">Forgot Password?</a>
	            </div>
	            <button type="submit" class="btn btn-default full-width" v-bind:disabled="(form.email == '' || form.password == '') || loading == true">{{loading ? 'Loading' : 'Login'}}</button>
	            <p class="register-link">Not a member yet?<a href="https://members.asifa-hollywood.org/members/signup">Create your account now.</a></p>
	        </form>
	    </div>
	</div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'LoginForm',
  data() {
  	return {
  		form: {
  			email: '',
  			password: ''
  		},
  		errors: '',
		loading: false
  	}
  },
  methods: {
  	SubmitForm:function(){
  		let that = this
		this.loading = true
  		axios
			.post('/api/users/login', {
				email: that.form.email,
				password: that.form.password,
				headers: {"Access-Control-Allow-Origin": "*"}
			})
			.then((response) => {
				// redirect to dashboard
				if(response.status == 200) window.location.href = response.data.redirectUrl.success.replace('http://','https://')
			})
			.catch(error => {
				if(error.response.status == 403) {
					that.errors = 'Email or password is incorrect.'
					that.form.password = ''
				}
				this.loading = false
		    })
  	}
  }
}
</script>

<style scoped>
	
</style>



// WEBPACK FOOTER //
// ./src/components/LoginForm.vue